module.exports = __webpack_public_path__ + "img/4.eca09dac.jpg";